<template>
    <div>
        <v-dialog v-model="value" max-width="60%" persistent>
            <v-card class="elevation-16 mx-auto">
              <v-card-title class="headline" primary-title>
                {{ $t('profile.title')  }}
                <v-spacer></v-spacer>
                <v-icon @click="closeDialog()">close</v-icon>
              </v-card-title>

              <v-divider></v-divider>
              <v-card-text>
                <v-container align="center">
                    <v-row class="mb-4 ml-2" align="center">
                        <v-avatar size="120px" class="mr-4">
                            <img v-if="editedItem.avatar" :src="baseImage + editedItem.avatar"/>
                            <img v-else src='@/assets/avatar_default.png'/>
                        </v-avatar>

                        <v-rating v-model="rating"
                            color="yellow darken-3"
                            background-color="grey darken-1"
                            empty-icon="$ratingFull"
                            half-increments
                            large
                            readonly
                        ></v-rating>
                    </v-row>

                    <v-row no-gutters>
                        <v-col cols="12" sm="12" >
                            <v-btn color="primary" @click="showResetPasswordDialog" v-if="userCategory > 2 | isAdmin"> {{ $t('changePass.btn_title') }} </v-btn>
                        </v-col>

                        <v-col cols="12" sm="6" class="pr-2 pt-5">
                            <v-text-field v-bind:label="$t('profile.email')" :value="editedItem.email" outlined readonly dense></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" class="pl-2 pt-5">
                            <v-text-field :value="editedItem.nickname" v-bind:label="$t('profile.nickname')" outlined readonly dense></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row no-gutters>
                        <v-col cols="12" sm="6" class="pr-2">
                            <v-text-field :value="editedItem.fullname" v-bind:label="$t('profile.fullname')" outlined readonly dense></v-text-field>
                        </v-col>
                
                        <v-col cols="12" sm="6" class="pl-2">
                            <v-text-field :value="dateToDisplay(editedItem.birthday)" v-bind:label="$t('profile.birthday')" outlined readonly dense></v-text-field>
                        </v-col>
                
                        <v-col cols="12" sm="6" class="pr-2">
                            <v-text-field :value="editedItem.phone" v-bind:label="$t('profile.phone')" outlined readonly dense></v-text-field>
                        </v-col>
                
                        <v-col cols="12" sm="6" class="pl-2">
                            <v-text-field :value="editedItem.identify" v-bind:label="$t('profile.identify')"  outlined readonly dense></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" class="pr-2">
                            <v-text-field :value="addressToString(editedItem.address)" v-bind:label="$t('profile.address')" outlined readonly dense></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" class="pl-2">
                            <v-text-field :value="dateToDisplay(editedItem.join_date)" v-bind:label="$t('profile.join_date')" outlined readonly dense></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12">
                            <v-text-field :value="getJobDisplay(editedItem.job)" v-bind:label="$t('job_management.role')" outlined readonly dense></v-text-field >
                        </v-col>

                        <v-col cols="12" sm="12">
                            <v-text-field :value="getPathJob(editedItem.job)" v-bind:label="$t('job_management.context')" outlined readonly dense></v-text-field >
                        </v-col>
                    </v-row>

                </v-container>
              </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="resetPassDialog" max-width="400px">
            <v-card class="elevation-16 mx-auto">
                <v-card-title class="headline" primary-title>
                    {{ $t('changePass.title')}}
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row align="center" justify="center">
                            <v-col cols="12" sm="11">
                                <v-text-field v-model="password" :append-icon="showNew ? 'visibility' : 'visibility_off'" :rules="passdRules" v-bind:label="$t('changePass.new_pass')"
                                 outlined :type="showNew ? 'text' : 'password'" required @click:append="showNew = !showNew"> </v-text-field>
                            </v-col>

                            <v-col cols="12" sm="11">
                                <v-text-field v-model="confirmPassword" :error-messages="vertifyPassword" :append-icon="showConfirm ? 'visibility' : 'visibility_off'" :rules="passdRules"
                                 v-bind:label="$t('changePass.repeat_new_pass')"  outlined :type="showConfirm ? 'text' : 'password'" required @click:append="showConfirm = !showConfirm"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn dark color="primary" @click="resetPassword" width="200px">
                        {{ $t('common.ok') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import moment from 'moment';
    import i18n from '@/plugins/i18n';

    export default {
        name: 'user-infor-dialog',

        props: {
            value: Boolean,
            editedItem: Object
        },


        data: ()=> ({
            baseImage: process.env.VUE_APP_BASE_IMAGE,
            baseAttach: process.env.VUE_APP_BASE_ATTACH,
            rating: 0,
            resetPassDialog: false,
            userCategory: parseInt(localStorage.getItem('category')),
            isAdmin: localStorage.getItem('isAdmin') === 'true' ? true : false,

            password: '',
            confirmPassword: '',
            showNew: false,
            showConfirm: false,
            valid: true,

            passdRules: [
                v => !!v || i18n.t('validate.password_require'),
                v => (v && v.length > 5) || i18n.t('validate.password_invalid'),
            ],
        }),

        computed: {
            vertifyPassword() {
                return this.password === this.confirmPassword ? '' : i18n.t('validate.not_match');
            }
        },

        watch: {
            selectProvince (val) {
                if (!this.firstEdit) {
                    this.selectWard = null;
                }

                if (val && val.province_id) {
                    this.getDistrictByProvinceID(val.province_id);
                } 
            },

            selectDistrict (val) {
                if (val && val.district_id) {
                    this.getWardByDistrictID(val.district_id);
                }
            },

            dialogAddAddress (val) {
                val || this.closeAddAddress()
            },
        },

        mounted() {
            if (this.editedItem.count_rate > 0) {
                this.rating = (this.editedItem.total_rate  / this.editedItem.count_rate) / 2.0
            } else {
                this.rating = 0;
            }
        },

        created () {
            
        },

        
        methods: {
            dateToDisplay(date) {
                return moment(date).format("DD/MM/YYYY");
            },

            getJobDisplay(job) {
                if (!job) {
                    return '';
                }

                return job.title;
            },

            addressToString(address) {
                if (address && address.fullDetail) {
                    return address.fullDetail;
                } else {
                    return '';
                }
            },

            getPathJob(job) {
                if (!job || !job.context) {
                    return '';
                }

                if (job.context) {
                    if (job.context.parents && job.context.parents.length > 0) {
                       if (job.context.parents.length == 2) {
                           return job.context.parents[0].name + "/" + job.context.parents[1].name + "/" + job.context.name;
                       } else {
                           return job.context.parents[0].name + "/" + job.context.name;
                       }
                    } else {
                        return job.context.name;
                    }
                }
            },

            closeDialog() {
                this.$emit('closeDialog', false);
            },

            showResetPasswordDialog() {
                const agree = confirm(i18n.t('changePass.confirm_reset_pass'));
                if (agree) {
                    this.resetPassDialog = true;
                }
            },

            closeResetPassword() {
                this.resetPassDialog = false;
            },

            async resetPassword() {
                const self = this;
                const requestBody = {
                    password: self.password
                };

                if (!self.password || self.password.length == 0) {
                    alert(i18n.t('validate.infor_empty'));
                    return;
                }

                if (!self.confirmPassword || self.confirmPassword.length == 0) {
                    alert(i18n.t('validate.infor_empty'));
                    return;
                }

                if (this.password !== this.confirmPassword) {
                    alert(i18n.t('validate.not_match'));
                    return;
                }

                try {
                    // console.log(requestBody);
                    const response =  await this.$http.post(process.env.VUE_APP_RESET_PASS_URL + self.editedItem._id, requestBody);
                    if (response.data && response.data.success) {
                        // console.log(response.data);

                        this.$fire({
                            title: i18n.t('changePass.change_success'),
                            text: "",
                            type: "success"
                            }).then(() => {
                                self.closeResetPassword();
                        });
                    } else {
                        alert(i18n.t('validate.request_error'));
                    }
                } catch(e) {
                    console.log(e.stack);
                    // alert(e.message);
                    alert(i18n.t('validate.request_error'));
                }
            }
        }
    }
</script>

<style scoped>

  .v-text-field .v-input__control .v-input__slot {
    min-height: 45px !important;
    /* display: flex !important; */
    align-items: center !important;
  }
</style>

